<template>
    <div class="w-full flex flex-wrap mx-auto -px-2">
        <div class="w-full hidden lg:block px-2 lg:w-1/5">
            <sidebar :links="links" />
        </div>
        <div class="w-full lg:w-4/5 px-2">
            <router-view :key="$route.name"></router-view>
        </div>
    </div>
</template>

<script>
import Sidebar from "./sidebar";

export default {
    components: {
        Sidebar
    },

    data() {
        return {
            links: [
                {
                    title: "Счета",
                    route: {
                        name: "admin.assets.accounts.index"
                    },
                    icon: "fas fa-money-check",
                    index: null,
                    show: this.can("manage-assets")
                },

                {
                    title: "Фонды",
                    route: {
                        name: "admin.assets.funds.index"
                    },
                    icon: "fas fa-piggy-bank",
                    index: null,
                    show: this.can("manage-assets")
                },

                {
                    title: "Филиалы",
                    route: {
                        name: "admin.branches.index"
                    },
                    icon: "fas fa-university",
                    index: null,
                    show: this.can("manage-branches")
                },

                {
                    title: "Категории товаров",
                    route: {
                        name: "admin.products.categories.index"
                    },
                    icon: "fas fa-briefcase",
                    show: this.can("manage-product-categories")
                },

                /*{
                    title: "Настройка CRM",
                    route: {
                        name: "admin.crm.settings"
                    },
                    icon: "fas fa-tasks",
                    show: this.can("manage-settings")
                }*/
            ]
        };
    }
};
</script>
